// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1hf6I","errorLogs":"styles_errorLogs__2aFZI"};